import React, { useEffect, useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import GrouptripsDtlbannersec from "../Components/GrouptripsDtlbannersec";
import GrouptripsDtlmenu from "../Components/GrouptripsDtlmenu";
import GrouptripsDtlcoverdside from "../Components/GrouptripsDtlcoverdside";
import GrouptripsDtlsimilar from "../Components/GrouptripsDtlsimilar";
import CommonSection from '../Components/CommonSection';

const GroupTripsDtl = () => {
  const [activeTab, setActiveTab] = useState("about");

  const sections = ["about", "itinerary", "details", "faqs"];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + 120;

      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
          const top = el.offsetTop;
          const height = el.offsetHeight;
          if (scrollPos >= top && scrollPos < top + height) {
            setActiveTab(id);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({
        top: el.offsetTop - 90,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <Header />

      <div className="min-h-screen bg-slate-50">
        

        <GrouptripsDtlbannersec />

        {/* ================= CONTENT ================= */}
        <section className="container mx-auto px-4 pb-24 md:pb-0 md:px-4">
          <div className="mt-5 md:mt-10 md:grid md:grid-cols-3 md:gap-8 lg:gap-12">
            {/* Sticky Tabs */}
            
          <div className="w-full md:col-span-2">
          <div className="sticky top-[79px] z-20 bg-white rounded-xl shadow-sm border border-slate-100 mb-6">
            <div className="flex overflow-x-auto scrollbar-hide">
              {sections.map((tab) => (
                <button
                  key={tab}
                  onClick={() => scrollToSection(tab)}
                  className={`flex-1 min-w-[80px] py-3 px-4 text-sm font-medium transition-colors ${
                    activeTab === tab
                      ? "text-primary border-b-2 border-primary bg-primary/5"
                      : "text-slate-600"
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>
          </div>
          
            <GrouptripsDtlmenu />

          </div>


            <GrouptripsDtlcoverdside />

          </div>
        </section>


            <section className="py-8 md:py-12 bg-gradient-to-br from-teal-500 to-teal-600">
            <div className="container mx-auto px-4">
              <div className="text-center mb-6 md:mb-8">
                <h2 className="text-xl md:text-2xl font-bold text-white mb-2">
                  Why Choose Connecting Traveller?
                </h2>
                <p className="text-white/90 text-sm md:text-base max-w-2xl mx-auto">
                  Join thousands of happy travelers who trust us for their adventures
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                <div className="bg-white rounded-xl p-4 md:p-5 text-center hover:shadow-xl transition-shadow">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-shield w-6 h-6 md:w-7 md:h-7 text-teal-600"
                    >
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                    </svg>
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-slate-800 mb-2">
                    Expert Guides
                  </h3>
                  <p className="text-slate-600 text-xs md:text-sm leading-relaxed">
                    10+ years of experience organizing safe and memorable trips across
                    India
                  </p>
                </div>
                <div className="bg-white rounded-xl p-4 md:p-5 text-center hover:shadow-xl transition-shadow">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-tag w-6 h-6 md:w-7 md:h-7 text-teal-600"
                    >
                      <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                      <path d="M7 7h.01" />
                    </svg>
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-slate-800 mb-2">
                    Best Prices
                  </h3>
                  <p className="text-slate-600 text-xs md:text-sm leading-relaxed">
                    Transparent pricing with no hidden costs. Get the best value for
                    your money
                  </p>
                </div>
                <div className="bg-white rounded-xl p-4 md:p-5 text-center hover:shadow-xl transition-shadow">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users w-6 h-6 md:w-7 md:h-7 text-teal-600"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-slate-800 mb-2">
                    24/7 Support
                  </h3>
                  <p className="text-slate-600 text-xs md:text-sm leading-relaxed">
                    Round-the-clock assistance before, during, and after your trip
                  </p>
                </div>
                <div className="bg-white rounded-xl p-4 md:p-5 text-center hover:shadow-xl transition-shadow">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star w-6 h-6 md:w-7 md:h-7 text-teal-600"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-slate-800 mb-2">
                    Flexible Booking
                  </h3>
                  <p className="text-slate-600 text-xs md:text-sm leading-relaxed">
                    Easy cancellation and rescheduling options for peace of mind
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="py-8 md:py-12 bg-slate-50">
            <div className="container mx-auto px-4">
              <div className="text-center mb-6 md:mb-8">
                <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-2">
                  What Travelers Say
                </h2>
                <p className="text-slate-600 text-sm md:text-base max-w-2xl mx-auto">
                  Real experiences from real travelers
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                <div className="bg-white rounded-xl p-4 md:p-5 border-t-4 border-teal-500 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center text-white text-base md:text-lg font-bold">
                      R
                    </div>
                    <div>
                      <h4 className="text-sm md:text-base font-bold text-slate-800">
                        Rohan P.
                      </h4>
                      <p className="text-xs text-slate-500">Feb 2024</p>
                    </div>
                  </div>
                  <div className="flex mb-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </div>
                  <p className="text-slate-600 text-xs md:text-sm leading-relaxed">
                    This was hands down the best trip of my life! The landscapes are
                    otherworldly, and the team took excellent care of us throughout. The
                    frozen Spiti River was surreal.
                  </p>
                </div>
                <div className="bg-white rounded-xl p-4 md:p-5 border-t-4 border-teal-500 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center text-white text-base md:text-lg font-bold">
                      P
                    </div>
                    <div>
                      <h4 className="text-sm md:text-base font-bold text-slate-800">
                        Priya K.
                      </h4>
                      <p className="text-xs text-slate-500">Jan 2024</p>
                    </div>
                  </div>
                  <div className="flex mb-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </div>
                  <p className="text-slate-600 text-xs md:text-sm leading-relaxed">
                    Worth every rupee! The expedition was well-organized, comfortable,
                    and thrilling all at once. The free goodies were a nice touch too!
                  </p>
                </div>
                <div className="bg-white rounded-xl p-4 md:p-5 border-t-4 border-teal-500 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center text-white text-base md:text-lg font-bold">
                      M
                    </div>
                    <div>
                      <h4 className="text-sm md:text-base font-bold text-slate-800">
                        Michael D.
                      </h4>
                      <p className="text-xs text-slate-500">Dec 2023</p>
                    </div>
                  </div>
                  <div className="flex mb-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </div>
                  <p className="text-slate-600 text-xs md:text-sm leading-relaxed">
                    As someone who has traveled extensively, Spiti in winter is truly
                    special. The guides were knowledgeable and the 4x4 experience was
                    top-notch.
                  </p>
                </div>
              </div>
            </div>
          </section>
          
          <GrouptripsDtlsimilar />

          <section className="py-8 md:py-12 bg-slate-50">
            <div className="container">
              <div className='mx-auto px-4 max-w-4xl'>
                <div className="text-center mb-6 md:mb-8">
                <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-2">
                  Frequently Asked Questions
                </h2>
                <p className="text-slate-600 text-sm md:text-base">
                  Got questions? We've got answers
                </p>
              </div>
              <div className="space-y-4">
                <div className="bg-white rounded-xl p-4 md:p-5 shadow-sm border-l-4 border-teal-500">
                  <h3 className="text-sm md:text-base font-bold text-slate-800 mb-2 flex items-start">
                    <span className="inline-block w-6 h-6 md:w-7 md:h-7 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center mr-2 md:mr-3 flex-shrink-0 font-bold text-xs">
                      Q
                    </span>
                    Is this trip suitable for first-timers?
                  </h3>
                  <p className="text-slate-600 text-xs md:text-sm leading-relaxed ml-8 md:ml-10">
                    While no prior experience is needed, you should be comfortable with
                    cold weather and basic physical challenges. Our guides provide full
                    support throughout.
                  </p>
                </div>
                <div className="bg-white rounded-xl p-4 md:p-5 shadow-sm border-l-4 border-teal-500">
                  <h3 className="text-sm md:text-base font-bold text-slate-800 mb-2 flex items-start">
                    <span className="inline-block w-6 h-6 md:w-7 md:h-7 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center mr-2 md:mr-3 flex-shrink-0 font-bold text-xs">
                      Q
                    </span>
                    What about altitude sickness?
                  </h3>
                  <p className="text-slate-600 text-xs md:text-sm leading-relaxed ml-8 md:ml-10">
                    We carry oxygen cylinders and first aid. Our itinerary is designed
                    with gradual altitude gain. If you have any medical conditions,
                    please consult your doctor before booking.
                  </p>
                </div>
                <div className="bg-white rounded-xl p-4 md:p-5 shadow-sm border-l-4 border-teal-500">
                  <h3 className="text-sm md:text-base font-bold text-slate-800 mb-2 flex items-start">
                    <span className="inline-block w-6 h-6 md:w-7 md:h-7 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center mr-2 md:mr-3 flex-shrink-0 font-bold text-xs">
                      Q
                    </span>
                    How cold does it get?
                  </h3>
                  <p className="text-slate-600 text-xs md:text-sm leading-relaxed ml-8 md:ml-10">
                    Temperatures can drop to -15°C to -20°C at night. Warm clothing is
                    essential. We provide tips on what to pack after booking.
                  </p>
                </div>
                <div className="bg-white rounded-xl p-4 md:p-5 shadow-sm border-l-4 border-teal-500">
                  <h3 className="text-sm md:text-base font-bold text-slate-800 mb-2 flex items-start">
                    <span className="inline-block w-6 h-6 md:w-7 md:h-7 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center mr-2 md:mr-3 flex-shrink-0 font-bold text-xs">
                      Q
                    </span>
                    Are mobile networks available?
                  </h3>
                  <p className="text-slate-600 text-xs md:text-sm leading-relaxed ml-8 md:ml-10">
                    Network connectivity is limited in Spiti. BSNL and Airtel work in
                    some areas. It's a perfect digital detox opportunity!
                  </p>
                </div>
              </div>
              </div>
            </div>
          </section>

        {/* Fixed bottom bar for mobile */}
        
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-lg md:hidden">
          <div className="px-4 py-3">
            <div className="flex items-center justify-between gap-4">
              <div>
                <div className="flex items-baseline gap-1.5">
                  <span className="text-xl font-bold text-slate-800">
                    ₹ {/* */}36,999
                  </span>
                  <span className="text-xs text-slate-500 line-through">
                    ₹ {/* */}41,999
                  </span>
                </div>
                <p className="text-xs text-slate-600 mt-0.5">
                  6 nights / 7 days{/* */} • {/* */}3{/* */} spots left
                </p>
              </div>
              <a target="_blank" href="https://wa.me/918920866123" className="inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 py-2 bg-primary text-white hover:bg-primary/90 h-11 px-8 text-sm font-semibold rounded-full shadow-lg">
                Book Now
              </a>
            </div>
          </div>
        </div>

      </div>

      <Footer />
    </>
  );
};

export default GroupTripsDtl; 